import { max, compare, min } from "../../fable_modules/fable-library-js.4.19.3/Util.js";
import { NotesProps, WorldLabel_$reflection, StaticLabel_$reflection, StaticLabel } from "./NotesBindings.js";
import { map, defaultArg } from "../../fable_modules/fable-library-js.4.19.3/Option.js";
import { VisualizationNoteViewModel_$reflection, VisualizationNoteViewModel } from "../../RAWMap.Models/View/VisualizationNote.js";
import { Record, Union } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { bool_type, option_type, record_type, array_type, tuple_type, lambda_type, list_type, class_type, union_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { ErrorMessage_$reflection } from "../../RAWMap.Models/ErrorMessage.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.19.3/Result.js";
import { CustomReportStatus_$reflection } from "../../RAWMap.Models/View/CustomReport.js";
import { InteractionMode_$reflection, Bounds_$reflection } from "../Common/CommonBindings.js";
import { map as map_1, toArray } from "../../fable_modules/fable-library-js.4.19.3/List.js";
import { UserData_$reflection, UserRole_$reflection } from "../../RAWMap.Models/Security.js";
import { Security_UserInfo$2_$reflection } from "../../fable_modules/Webbler.Models.1.6.0/Api.fs.js";
import { String_wordWrap } from "../../Common/Extensions.js";
import { wrapInboundMsg } from "../../Common/InboundOutbound.js";

export function StaticLabel_ofVisualizationNoteViewModel(bounds, noteVm) {
    const clamp = (minVal, maxVal, value) => min(compare, maxVal, max(compare, minVal, value));
    const x_2 = clamp(1, bounds.width - 15, noteVm.x * bounds.width);
    const y_2 = clamp(1, bounds.height, noteVm.y * bounds.height);
    return new StaticLabel(noteVm.noteId, noteVm.content, 0, x_2 / bounds.width, y_2 / bounds.height, x_2, y_2, noteVm.isHidden, false);
}

export function VisualizationNoteViewModel_convertFromLabelCoordinates(bounds, label, noteVm) {
    const divideByOrZero = (divisor, arg) => defaultArg(map((d) => (d / divisor), arg), 0);
    return new VisualizationNoteViewModel(noteVm.studyId, noteVm.noteId, noteVm.content, divideByOrZero(bounds.width, label.x), divideByOrZero(bounds.height, label.y), noteVm.isHidden);
}

export class Mode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Normal", "Disabled", "MoveNotes", "CreateNote", "EditNote", "DeleteNote"];
    }
}

export function Mode_$reflection() {
    return union_type("Client.Visualization.Notes.Types.Mode", [], Mode, () => [[], [], [], [["Item", VisualizationNoteViewModel_$reflection()]], [["Item", VisualizationNoteViewModel_$reflection()]], [["Item", VisualizationNoteViewModel_$reflection()]]]);
}

export class LocalMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExnErrorMsg", "GetNotes", "GetNotesResult", "EditNote", "SetVisualizationNoteVm", "SaveNote", "CreateNoteResult", "EditNoteResult", "DeleteNote", "ConfirmDeleteNote", "DeleteNoteResult", "SaveNotePositions", "SaveNotePositionsResult", "Cancel", "MoveNotes", "CreateNote", "ToggleNoteVisibility"];
    }
}

export function LocalMsg_$reflection() {
    return union_type("Client.Visualization.Notes.Types.LocalMsg", [], LocalMsg, () => [[["Item", class_type("System.Exception")]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(VisualizationNoteViewModel_$reflection()), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(VisualizationNoteViewModel_$reflection())]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", VisualizationNoteViewModel_$reflection()]], [["Item", lambda_type(VisualizationNoteViewModel_$reflection(), VisualizationNoteViewModel_$reflection())]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(CustomReportStatus_$reflection(), VisualizationNoteViewModel_$reflection()), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", tuple_type(CustomReportStatus_$reflection(), VisualizationNoteViewModel_$reflection())]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(CustomReportStatus_$reflection(), VisualizationNoteViewModel_$reflection()), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", tuple_type(CustomReportStatus_$reflection(), VisualizationNoteViewModel_$reflection())]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", VisualizationNoteViewModel_$reflection()]], [["Item", VisualizationNoteViewModel_$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [tuple_type(CustomReportStatus_$reflection(), VisualizationNoteViewModel_$reflection()), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", tuple_type(CustomReportStatus_$reflection(), VisualizationNoteViewModel_$reflection())]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [], [["noteIdResults", array_type(tuple_type(class_type("System.Guid"), union_type("Microsoft.FSharp.Core.FSharpResult`2", [CustomReportStatus_$reflection(), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", CustomReportStatus_$reflection()]], [["ErrorValue", ErrorMessage_$reflection()]]])))]], [], [], [], [["noteId", class_type("System.Guid")]]]);
}

export class InboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["StaticLabelMoved", "ViewportResized", "DisableInteractions", "EnableInteractions", "HideAllNotes"];
    }
}

export function InboundMsg_$reflection() {
    return union_type("Client.Visualization.Notes.Types.InboundMsg", [], InboundMsg, () => [[["Item", StaticLabel_$reflection()]], [["Item", Bounds_$reflection()]], [], [], []]);
}

export class OutboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateCustomReportStatus", "SetInteractionModeOutbound"];
    }
}

export function OutboundMsg_$reflection() {
    return union_type("Client.Visualization.Notes.Types.OutboundMsg", [], OutboundMsg, () => [[["Item", CustomReportStatus_$reflection()]], [["Item", InteractionMode_$reflection()]]]);
}

export class LabelData extends Record {
    constructor(worldLabels, staticLabels) {
        super();
        this.worldLabels = worldLabels;
        this.staticLabels = staticLabels;
    }
}

export function LabelData_$reflection() {
    return record_type("Client.Visualization.Notes.Types.LabelData", [], LabelData, () => [["worldLabels", array_type(WorldLabel_$reflection())], ["staticLabels", array_type(StaticLabel_$reflection())]]);
}

export function LabelData_setStaticLabels(bounds, labelData, noteVms) {
    return new LabelData(labelData.worldLabels, toArray(map_1((noteVm) => StaticLabel_ofVisualizationNoteViewModel(bounds, noteVm), noteVms)));
}

export class ModelNotes extends Record {
    constructor(MaybeCurrentUser, SelectedStudyId, LabelData, Notes, ModifiedStaticLabels, Mode, IsSaving) {
        super();
        this.MaybeCurrentUser = MaybeCurrentUser;
        this.SelectedStudyId = SelectedStudyId;
        this.LabelData = LabelData;
        this.Notes = Notes;
        this.ModifiedStaticLabels = ModifiedStaticLabels;
        this.Mode = Mode;
        this.IsSaving = IsSaving;
    }
}

export function ModelNotes_$reflection() {
    return record_type("Client.Visualization.Notes.Types.ModelNotes", [], ModelNotes, () => [["MaybeCurrentUser", option_type(Security_UserInfo$2_$reflection(UserRole_$reflection(), UserData_$reflection()))], ["SelectedStudyId", class_type("System.Guid")], ["LabelData", LabelData_$reflection()], ["Notes", list_type(VisualizationNoteViewModel_$reflection())], ["ModifiedStaticLabels", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [class_type("System.Guid"), StaticLabel_$reflection()])], ["Mode", Mode_$reflection()], ["IsSaving", bool_type]]);
}

export function ModelNotes__Props_25828286(x, dispatch) {
    return new NotesProps(x.LabelData.staticLabels, (toWrap) => String_wordWrap(40, toWrap), x.LabelData.worldLabels, (arg_1) => {
        dispatch(wrapInboundMsg(new InboundMsg(0, [arg_1])));
    });
}

